import { combineReducers } from '@reduxjs/toolkit';
import createCompanyReducer from './create/createSlice';
import companyListReducer from './list/listSlice';
import deleteCompanyReducer from './delete/deleteSlice';

const companySlice = combineReducers({
    create: createCompanyReducer,
    list: companyListReducer,
    delete: deleteCompanyReducer,
});

export default companySlice;
